/* bsv4-nod-extras.js — small presentation add-ons for the by-size v4 pages
 * (dtf-imgix + uv-by-size-imgix), per Justin's 2026-07-25 mocks:
 *
 *  1. Step-2 footer aggregate — "75 pcs · $144.50" at the right of the
 *     "Add another size of this design" footer. Sums the live row DOM
 *     (qty inputs + painted total cells); no pricing math re-implemented.
 *  2. Step-1 PREVIEW caption — "PREVIEW  Prints exactly as shown, at this
 *     size." between the checkerboard stage and the AI-tool toggle rows
 *     (styled/ordered by bysize-v4-nod-skin2.css).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-bsv4-root]');
  if (!root) return;

  var MONEY = /\$\s*([\d,]+(?:\.\d+)?)/;

  function money(n) { return '$' + n.toFixed(2); }

  /* ---- 1. step-2 footer aggregate ---- */
  function updateSums() {
    var footers = root.querySelectorAll('.bsv4-sizing__footer');
    [].forEach.call(footers, function (footer) {
      var sum = footer.querySelector('[data-bsv4-sum]');
      if (!sum) return;
      var scope = footer.parentElement || root;
      var rows = scope.querySelectorAll('[data-bsv4-rows] [data-bsv4-row]');
      var qty = 0, total = 0, any = false;
      [].forEach.call(rows, function (row) {
        var q = row.querySelector('[data-bsv4-qty]');
        var qv = q ? parseInt(q.value, 10) : 0;
        if (qv > 0) qty += qv;
        var t = row.querySelector('[data-bsv4-row-total]');
        /* the cell may contain a struck-through was-price first — take the
           LAST money token (the live discounted total) */
        var ms = t && (t.textContent || '').replace(/,/g, '').match(/\$\s*[\d.]+/g);
        if (ms && ms.length) { total += parseFloat(ms[ms.length - 1].replace(/[^\d.]/g, '')); any = true; }
      });
      if (!any || !(qty > 0)) {
        if (sum.style.display !== 'none') sum.style.display = 'none';
        return;
      }
      /* write only on change — the MutationObserver below watches
         characterData, so unconditional writes would self-retrigger */
      var pcs = sum.querySelector('.bsv4-sum__pcs');
      var tot = sum.querySelector('.bsv4-sum__total');
      var pcsTxt = qty + ' pcs', totTxt = money(total);
      if (pcs && pcs.textContent !== pcsTxt) pcs.textContent = pcsTxt;
      if (tot && tot.textContent !== totTxt) tot.textContent = totTxt;
      if (sum.style.display === 'none') sum.style.display = '';
    });
  }

  /* ---- 2. step-1 PREVIEW caption ---- */
  function ensureCaption() {
    var bodies = root.querySelectorAll('.bsv4-preview__body');
    [].forEach.call(bodies, function (body) {
      if (body.querySelector('.bsv4-prevcap')) return;
      var p = document.createElement('p');
      p.className = 'bsv4-prevcap';
      p.innerHTML = '<b>PREVIEW</b> Prints exactly as shown, at this size.';
      body.appendChild(p);
    });
  }

  var t = null;
  function run() {
    t = null;
    try { ensureCaption(); } catch (e) {}
    try { updateSums(); } catch (e) {}
  }

  run();
  root.addEventListener('input', function () { if (!t) t = setTimeout(run, 120); });
  new MutationObserver(function () {
    if (!t) t = setTimeout(run, 150);
  }).observe(root, { childList: true, subtree: true, characterData: true });
})();
